import { render, staticRenderFns } from "./TimKiem.vue?vue&type=template&id=2807b3d4&"
import script from "./TimKiem.vue?vue&type=script&lang=js&"
export * from "./TimKiem.vue?vue&type=script&lang=js&"
import style0 from "./TimKiem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports